import * as React from 'react';
import { FC } from 'react';
import { COLORS } from '../../main/utils/Colors';

interface ContainerIconProps {
  color: string;
  width: number;
  height: number;
  fillColor?: string;
}

export const ContainerIcon: FC<ContainerIconProps> = ({ color, width, height, fillColor = COLORS.WHITE }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
    <rect x="2.5" width="15" height="20" rx="2" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor}
      d="M5 1.5C4.44772 1.5 4 1.94772 4 2.5V13.5C4 14.0523 4.44772 14.5 5 14.5H12C12.5523 14.5 13 14.0523 13 13.5V2.5C13 1.94772 12.5523 1.5 12 1.5H5ZM14 2C14 1.72386 14.2239 1.5 14.5 1.5H15.5C15.7761 1.5 16 1.72386 16 2V4C16 4.27614 15.7761 4.5 15.5 4.5H14.5C14.2239 4.5 14 4.27614 14 4V2ZM16 8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8Z"
    />
  </svg>
);
